/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useAppSelector } from 'src/store';

import * as urlFor from 'src/shared/helpers/urlHelper';

import { getVepSubmissionsList } from 'src/content/app/tools/vep/state/vep-submissions/vepSubmissionsSelectors';

import ButtonLink from 'src/shared/components/button-link/ButtonLink';

import styles from './VepTopBar.module.css';

const VepTopBarNavButtons = () => {
  const vepSubmissions = useAppSelector(getVepSubmissionsList);
  const hasSubmissions = vepSubmissions.length > 0;

  return (
    <div className={styles.jobListNavigation}>
      <ButtonLink to={urlFor.vepSubmissionsList()} isDisabled={!hasSubmissions}>
        Jobs list
      </ButtonLink>
    </div>
  );
};

export default VepTopBarNavButtons;
